import CONSTANTS from 'tradera-constants/state';
import { nullifyUndefinedProperties } from 'tradera-utils/object';
import {
    DEFAULT_COOKIES,
    GDPR_CONSENT_ALERT_DISMISSED
} from 'tradera-constants/cookies';
import cookieUtil from 'tradera-utils/cookie';
import { cache, CACHE_KEYS } from 'tradera-utils/cache';
import uiActions from './actions';

export const getInitialBadges = () => ({
    messaging: {
        threads: 0,
        threadsUnread: 0
    },
    system: 0
});

export const getInitialState = ({
    cartItemCount,
    cartSum,
    isGdprModalOpen,
    itemLayout,
    messageThreadCount,
    messageThreadsUnreadCount,
    showHeaderSearch,
    showSearchForm,
    siteLayout,
    systemMessages
}) => {
    const gdpr = {
        modalOpen: isGdprModalOpen,
        settingsOpen: false
    };

    const badges = getInitialBadges();
    badges.messaging.threads = messageThreadCount;
    badges.messaging.threadsUnread = messageThreadsUnreadCount;

    return nullifyUndefinedProperties({
        cartItemCount,
        cartSum,
        categoryDropdownMenu: { open: CONSTANTS.MODAL.CLOSED },
        badges,
        gdpr,
        itemLayout: itemLayout,
        itemSettings: {
            open: CONSTANTS.MODAL.CLOSED,
            item: {}
        },
        messagingModal: {
            open: CONSTANTS.MODAL.CLOSED,
            title: '',
            src: '',
            participating: false,
            recipientId: '',
            item: null
        },
        modals: {
            currentModal: null
        },
        notificationOptinModal: {
            open: CONSTANTS.MODAL.CLOSED,
            modalType: null,
            gaLabel: null,
            title: null,
            description: null,
            tagGroups: []
        },
        profileMenu: { open: CONSTANTS.MODAL.CLOSED, redirectUrl: false },
        quickView: {
            open: CONSTANTS.MODAL.CLOSED,
            items: {},
            itemIds: [],
            currentItem: 0,
            loading: false
        },
        siteLayout,
        showHeaderSearch,
        showSearchForm,
        systemMessages: {
            BankAccountMissing: false,
            InvoiceOverdue: false,
            InvoiceUnpaid: false,
            PayoutFailed: false,
            PayoutReadyBankAccountMissing: false,
            SwishNumberMissing: false,
            ...systemMessages
        },
        videoModal: {
            open: CONSTANTS.MODAL.CLOSED,
            video: ''
        },
        youtubeVideoModal: {
            open: CONSTANTS.MODAL.CLOSED,
            video: ''
        },
        shareModal: {
            isOpen: false,
            settings: null
        }
    });
};

export const initializeFromInitData = initData => dispatch => {
    const headerElement = document.querySelector('[data-site-header-slim]');
    const cartItemCount = parseInt(
        headerElement?.getAttribute('data-cart-item-count') || '0'
    );
    const cartSum = parseInt(
        headerElement?.getAttribute('data-cart-sum') || '0'
    );

    const messagingBadges = cache.read(CACHE_KEYS.MESSAGING_BADGES) || {
        threads: 0,
        threadsUnread: 0
    };

    const state = getInitialState({
        cartItemCount,
        cartSum,
        isGdprModalOpen:
            cookieUtil.readCookie(GDPR_CONSENT_ALERT_DISMISSED) === null,
        itemLayout:
            cookieUtil.readCookie(DEFAULT_COOKIES['ITEM_LAYOUT'].key) ||
            DEFAULT_COOKIES['ITEM_LAYOUT'].default,
        messageThreadCount: messagingBadges.threads,
        messageThreadsUnreadCount: messagingBadges.threadsUnread,
        showHeaderSearch:
            initData.pageName && initData.pageName.includes('StartPage'),
        showSearchForm: !!initData.hasSearch,
        siteLayout:
            cookieUtil.readCookie(DEFAULT_COOKIES['SITE_LAYOUT'].key) ||
            DEFAULT_COOKIES['SITE_LAYOUT'].default,
        systemMessages: cache.read(CACHE_KEYS.SYSTEM_MESSAGES) || {}
    });
    dispatch(uiActions.initialize(state));
};
